module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/add-new-user-permission/add-new-user-permission.component.css
// module id = ./src/app/achelos-iot/modals/add-new-user-permission/add-new-user-permission.component.css
// module chunks = main